/**
 * DON'T USE THIS __private_useWholesaleCartAddToCart__ MUTATION DIRECTLY. Use
 * app/javascript/clinic/shared/hooks/useAddToCartWholesale/useAddToCartWholesale.tsx instead as that hook has all the code
 * needed to handle Minimum Advertised Price (MAP) policies and the dialogs that the user should see
 * if policy for a brand that's been added to cart is not agreed on by the user
 */

import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { WholesaleCart } from "@shared/data/splinters/WholesaleCart.fragment";
import { WHOLESALE_CART } from "@shared/data/splinters/WholesaleCart.fragment";
import type { StorePlatformType } from "@shared/types/graphqlGenerated";

const WholesaleCartAddToCart_Shared_Mutation = gql`
  mutation WholesaleCartAddToCart_Shared_Mutation($input: WholesaleCartAddToCartInput!) {
    wholesaleCartAddToCart(input: $input) {
      cart {
        ...WholesaleCart
      }
      errors {
        fields {
          mapAgreements
        }
        message
      }
    }
  }
  ${WHOLESALE_CART}
`;

interface WholesaleCartAddToCartData {
  wholesaleCartAddToCart: {
    cart: WholesaleCart;
    errors: {
      message: string;
      fields?: {
        mapAgreements: string[];
      };
    };
  };
}

interface WholesaleAddToCartVariables {
  variantId: string;
  quantity: number;
}

interface Variables {
  input: {
    cart: WholesaleAddToCartVariables[];
    storePlatform?: (typeof StorePlatformType)[keyof typeof StorePlatformType];
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
const __private_useWholesaleCartAddToCart__ = (
  options?: MutationHookOptions<WholesaleCartAddToCartData, Variables>
) =>
  useMutation<WholesaleCartAddToCartData, Variables>(
    WholesaleCartAddToCart_Shared_Mutation,
    options
  );

export type { WholesaleAddToCartVariables, WholesaleCartAddToCartData };
export { __private_useWholesaleCartAddToCart__, WholesaleCartAddToCart_Shared_Mutation };
